/**
 * Reads payment encryption config from React env vars.
 *
 * Feature flag:
 *   REACT_APP_ENABLE_ENCRYPTION  — "true" | "false" (default: true)
 *
 * When enabled, required:
 *   REACT_APP_PAYMENT_ENCRYPTION_PUBLIC_KEY  — SPKI PEM, \n escaped as \\n
 *   REACT_APP_PAYMENT_ENCRYPTION_KEY_ID      — must match backend PAYMENT_ENCRYPTION_KEY_ID
 */

export type PaymentEncryptionEnvConfig = {
  public_key_pem: string;
  key_id: string;
};

/** True unless REACT_APP_ENABLE_ENCRYPTION is explicitly "false" or "0". */
export function isPaymentEncryptionEnabled(): boolean {
  const raw = process.env.REACT_APP_ENABLE_ENCRYPTION?.trim().toLowerCase();
  if (raw === undefined || raw === "") {
    return true;
  }
  return raw === "true" || raw === "1" || raw === "yes";
}

export function getPaymentEncryptionConfig(): PaymentEncryptionEnvConfig {
  const rawPem = process.env.REACT_APP_PAYMENT_ENCRYPTION_PUBLIC_KEY;
  const keyId = process.env.REACT_APP_PAYMENT_ENCRYPTION_KEY_ID;

  if (!rawPem || !keyId) {
    throw new Error(
      "Payment encryption not configured. " +
        "Set REACT_APP_PAYMENT_ENCRYPTION_PUBLIC_KEY and REACT_APP_PAYMENT_ENCRYPTION_KEY_ID."
    );
  }

  const public_key_pem = rawPem.replace(/\\n/g, "\n").trim();

  if (
    !public_key_pem.includes("BEGIN PUBLIC KEY") ||
    !public_key_pem.includes("END PUBLIC KEY")
  ) {
    throw new Error(
      "REACT_APP_PAYMENT_ENCRYPTION_PUBLIC_KEY must be a valid SPKI PEM (BEGIN/END PUBLIC KEY)."
    );
  }

  return {
    public_key_pem,
    key_id: keyId,
  };
}
